import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import {
  AppRemixIcon,
  AppMultiSelect,
  AppSingleSelect,
} from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../helpers/Translator';
import { axiosPath } from '../../../../routing/helpers/router';
import errorHandler from '@/layout/components/error/ErrorHandler';
import useIsMounted from '../../hooks/useIsMounted';
import _ from 'lodash';

export default function StateSelect(props) {
  const {
    onHandleChange,
    value,
    error,
    isMulti = true,
    allowSelectAll = true,
    clientID = undefined,
    moduleBridgeHex = undefined,
    plantHex = undefined,
    hasSelectOptions = false,
    hideNotApplicable = false,
    hideObsolete = false,
    isClearable = false,
    isDisabled = false,
    required = false,
  } = props;
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [options, setOptions] = useState(null);
  const [selectedValue, setSelectedValue] = useState(undefined);

  // > LOAD STATES //
  const loadStates = async () => {
    axios
      .post(axiosPath('api_r_user_global_getStates'), {
        clientID,
        moduleBridgeHex,
        plantHex,
        hideNotApplicable,
        hideObsolete,
      })
      .then((r) => {
        if (isMounted.current) setOptions(r.data);
      })
      .catch((e) => dispatch(errorHandler(e)));
  };
  // < LOAD CHANGES

  useEffect(() => {
    loadStates();
  }, []);
  // < LOAD STATES //

  const transformOptions = (opts) => {
    if (isMulti) {
      if (opts !== null) {
        return opts.map((o) => ({
          id: Number.isInteger(o) ? o : parseInt(o.substring(1)),
          isCustom: !Number.isInteger(o),
        }));
      }

      return [];
    }

    if (opts !== null) {
      const selectedState = options.find((o) => o.value === opts);
      return {
        id: selectedState.isCustom
          ? parseInt(selectedState.value.substring(1))
          : selectedState.value,
          isCustom: selectedState.isCustom,
      };
    }

    return null;
  };

  useEffect(() => {
    if (value && options) {
      if (isMulti) {
        const valueIds = _.map(
          value.filter((v) => v.isCustom === false),
          'id'
        );
        const customValueIds = _.map(
          value.filter((v) => v.isCustom),
          'id'
        );
        const sv = options.filter(
          (s) =>
            (s.isCustom === false && valueIds.includes(s.value)) ||
            (s.isCustom &&
              customValueIds.includes(parseInt(s.value.substring(1))))
        );
        setSelectedValue(_.map(sv, 'value'));
      } else {
        setSelectedValue(value.isCustom ? `c${value.id}` : value.id);
      }
    } else {
        setSelectedValue(undefined);
    }
  }, [value, options]);

  return isMulti ? (
    <AppMultiSelect
      options={options}
      title={ReactDOMServer.renderToString(
        <Translator file="module-intelligence" name="states" />
      )}
      placeholder={ReactDOMServer.renderToString(
        <Translator file="user" name="select.one.or.multiple.states" />
      )}
      value={selectedValue || []}
      onChange={(opt) => onHandleChange(transformOptions(opt))}
      icon={<AppRemixIcon icon="apps-2" />}
      isLoading={!options}
      error={error}
      hasSearchBox
      hasSelectOptions={hasSelectOptions}
      isClearable={isClearable}
      isDisabled={isDisabled}
      required={required}
    />
  ) : (
    <AppSingleSelect
      options={options}
      title={ReactDOMServer.renderToString(
        <Translator file="module-intelligence" name="states" />
      )}
      placeholder={ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="select.state" />
      )}
      value={selectedValue}
      onChange={(opt) => onHandleChange(transformOptions(opt))}
      icon={<AppRemixIcon icon="apps-2" />}
      isLoading={!options}
      error={error}
      hasSearchBox
      hasSelectOptions={hasSelectOptions}
      isClearable={isClearable}
      isDisabled={isDisabled}
      required={required}
    />
  );
}
